export default __webpack_public_path__ + "static/media/taklif2.a571b761.svg";